import React from 'react';
import { Divider, Skeleton, Stack } from '@mui/material';
import { Card, IconButtonGroup, useMediaDevice } from '@travelity/ui';

const OtaCardSkeleton = () => {
    const { isMobile } = useMediaDevice();

    return (
        <Card
            parentProps={{ maxWidth: '320px' }}
            sx={{
                height: '148px',
            }}
            buttons={
                <IconButtonGroup
                    flexShrink={0}
                    sx={{ px: 0.75, py: 1 }}
                    gap={1.5}
                >
                    <Skeleton variant="circular" width={24} height={24} />
                </IconButtonGroup>
            }
            justifyContent="space-evenly"
        >
            <Stack
                gap={0.5}
                sx={{
                    py: 1,
                }}
            >
                <Stack
                    direction="row"
                    gap={2}
                    justifyContent="space-between"
                    sx={{
                        width: 1,
                        px: 2,
                    }}
                >
                    <Skeleton width={90} sx={{ fontSize: '24px' }} />
                </Stack>
                <Divider />
                <Stack
                    direction="row"
                    gap={2}
                    justifyContent="space-between"
                    sx={{
                        width: 1,
                        px: 2,
                    }}
                >
                    <Skeleton width={100} sx={{ fontSize: '24px' }} />
                    {!isMobile && (
                        <Stack direction="row" gap={1}>
                            <Skeleton width={100} sx={{ fontSize: '24px' }} />
                        </Stack>
                    )}
                </Stack>
                <Divider />
                <Stack
                    direction="row"
                    gap={2}
                    justifyContent="start"
                    sx={{
                        width: 1,
                        px: 2,
                    }}
                >
                    <Skeleton width={90} sx={{ fontSize: '24px' }} />
                    {!isMobile && (
                        <Skeleton width={110} sx={{ fontSize: '24px' }} />
                    )}
                </Stack>
            </Stack>
        </Card>
    );
};

export default OtaCardSkeleton;
